// extracted by mini-css-extract-plugin
export default {"myModal":"AddOnboardingModal_myModal__MMpKf","myModal__content":"AddOnboardingModal_myModal__content__SVCvX"};